// extracted by mini-css-extract-plugin
module.exports = {"item":"office-menu-module--item--2kQFd","mapLink":"office-menu-module--mapLink--3P7Dd"};